<template>
    <div>
        <card>
            <form>
                <fg-input v-model="localItem.name" :label="$t('system.settings.fields.name')" :disabled="true"></fg-input>

                <div v-if="$te('system.' + localItem.translationPath)">
                    <label>{{ $t('system.settings.fields.description') }}</label> <br>
                    <span>{{$t('system.' + localItem.translationPath)}}</span>
                </div>

                <div v-if="localItem.category != null && localItem.category.length > 0">
                    <label>{{ $t('system.settings.fields.categories') }}</label> <br>
                    <span v-for="cat of localItem.category" v-bind:key="cat" class="setting-category">{{cat}}&nbsp;</span>
                </div>

                <fg-input v-model="localItem.type" :label="$t('system.settings.fields.type')" :disabled="true"></fg-input>

                <div v-if="localItem.possibleValues != null">
                    <label>{{ $t('system.settings.fields.value') }}</label>
                    <vSelect  
                        :options="localItem.possibleValues"
                        v-model="localItem.value"
                        :clearable="false"/>
                </div>

                <div v-else-if="localItem.type === 'boolean'" >
                    <label>{{ $t('system.settings.fields.value') }}</label>
                    <b-form-checkbox value="true" unchecked-value="false" v-model="localItem.value" />
                </div>

                <div v-else>
                    <fg-input v-model="localItem.value" :label="$t('system.settings.fields.value')"></fg-input>
                </div>

                <FormButtons
                    @submit="onSubmit" 
                    :reset="false" 
                    :remove="false"
                    :disableSubmit="loading"/>

                <RequestInfo type="custom" :ok="ok" :error="error" :loader="loading" :errorMsg="errorMsg" :okMsg="okMsg"/>

            </form>
        </card>
    </div>
</template>

<script>

import vSelect from 'vue-select'


export default {
    name: "SettingsDetails",
    data: function() {
            return {
                loading: false,
                localItem: Object.assign({}, this.item), // Copy of this.item to not refresh SettingTable.vue automaticaly
                categoriesString: "",
                ok: false,
                error: false,
                errorMsg: "",
                okMsg: ""
            }
        },
    components: {
        vSelect
    },
    props: {
        item: { 
          default: null,
        },
        reopened: {
            default : false
        }
    },
    watch: {
        item(value) {
            this.loading = false;
            this.localItem = Object.assign({}, value); // Copy of this.item to not refresh SettingTable.vue automaticaly
            this.error = false;
            this.refreshRequestInfo();
        }
    },
    created: function(){
        this.okMsg = this.$t("system.settings.ok");
        this.refreshRequestInfo();
    },
    methods: {
        onSubmit(event) {
            if (event) event.preventDefault();
            this.error = false;
            this.ok = false;
            this.loading = true; 
            var params = {
                "id": this.localItem.id,
                "value": this.localItem.value
            }
            if(this.localItem.type == 'int'){
                if(!Number.isInteger(parseInt(this.localItem.value))){
                    this.error = true;
                    this.errorMsg = this.$t("system.settings.errorNotInteger");
                    this.loading = false; 
                    return;
                }
            }


            this.$store.dispatch('settings/changeSetting', params).then((response) => {
                setTimeout(() => { 
                    this.loading = false;
                    if(response.status != 200){
                        this.error = true;
                        this.errorMsg = response.status
                    }
                }, 1000);
             });
        },
        refreshRequestInfo(){
            if(this.reopened){
                this.ok = true;
            }else {
                this.ok = false;
            }
        }
    }
   
}
</script>

<style lang="scss">
    .setting-category {
        background-color: #6C757D;
        color: #F6FFFF;
        border-radius: 5px;
        margin: 5px;
        width: auto; 
        height: auto; 
        padding: 5px;
        font-size: 0.75rem;
    }
</style>

